import React from "react";
import { appConfig } from "@src/config/appConfig";
import { FlexBoxLinkProps } from "design-system/src/Core/Link/Context/DefaultFlexBoxLink";
import FlexBox from "design-system/src/Components/FlexBox/FlexBox";
import { navigate } from "gatsby-plugin-intl-sushishop";
import { isInternal, isStaticFile, opensNewTab } from "./navigationRules";

const FlexBoxLink = (props: FlexBoxLinkProps) => {
  const { sushishopBaseUrl } = appConfig;
  const {
    children,
    to,
    href = "",
    color: colorProps,
    ref,
    onClick,
    type,
    ...anchorRest
  } = props;
  const re = new RegExp(`^${sushishopBaseUrl}`, "i");
  const route = (to || href).replace(re, "");
  const javascript_uri = /^javascript:(.*)/.exec(route);
  //   return (
  //     <FlexBox as={Link} to={route} onClick={onClick} {...anchorRest}>
  //       {children}
  //     </FlexBox>
  //   );
  // }
  // if (!route || javascript_uri) {
  //   const { onClick, color, ...buttonRest } =
  //     anchorRest as ButtonHTMLAttributes<any>;
  //   const evalJs = () => {
  //     eval(javascript_uri ? javascript_uri[1] : "()=>{}");
  //   };
  //   return (
  //     <FlexBox
  //       as={"button"}
  //       {...buttonRest}
  //       color={colorProps}
  //       onClick={onClick || evalJs}
  //       type={type}
  //     >
  //       {children}
  //     </FlexBox>
  //   );
  // }

  const handleClick = (
    e:
      | React.MouseEvent<HTMLAnchorElement, MouseEvent>
      | React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    // Fichier statique (PDF, image…) ou nouvel onglet : laisser la navigation
    // navigateur native (<a href>) opérer plutôt que le routing SPA (→ 404 PWA
    // sinon). Cf. règles partagées navigationRules.ts (régression RUN-8018).
    if (isStaticFile(route) || opensNewTab(anchorRest.target)) {
      onClick?.(e as any);
      return;
    }
    e.preventDefault();
    if (isInternal(route)) {
      navigate(route);
    } else if (!route || javascript_uri) {
      eval(javascript_uri ? javascript_uri[1] : "()=>{}");
    } else {
      window.location.href = route;
    }
    onClick?.(e as any);
  };

  return (
    <FlexBox as={"a"} href={route} onClick={handleClick} {...anchorRest}>
      {children}
    </FlexBox>
  );
};

export default FlexBoxLink;
